import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { assoc, keys, reduce } from 'ramda';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { first, tap } from 'rxjs/operators';
import { LiveeTagsService } from '../livee.tags.service';
import { SessionBase } from '../session-base';

@Component({
  selector: 'app-appearence',
  templateUrl: './appearence.component.html',
  styleUrls: ['./appearence.component.scss']
})
export class SessionsAppearenceLiveeComponent extends SessionBase implements OnInit {

  public liveeTags: any = {};
  public previewHash;
  public loaded = false;

  public content_left = {
    simple_session: [
      {
        label: 'sessions.appearence.global.title',
        controls: [
          { type: 'file', tagName: 'session.logo', parseFn: this.parseImage, className: 'w25', label: 'sessions.appearence.global.logo' },
          { type: 'file', tagName: 'session.background', parseFn: this.parseImage, className: ['spl', 'w40'], bottomInfo: '1920 x 1080 px', label: 'sessions.appearence.global.bg_image' },
          { type: 'bg-filter', tagName: 'eevent.config', tagVar: 'backgroundFilter', tagVar2: 'backgroundFilterColor', className: ['spl', 'w35'], label: 'sessions.appearence.global.bg_color_filter.label' },
          { type: 'color', tagName: 'eevent.config', tagVar: 'mainColor', className: 'w100', label: 'sessions.appearence.global.main_color' },
          { type: 'color', tagName: 'eevent.config', tagVar: 'blockColor', className: 'w50', label: 'sessions.appearence.global.block_color' },
          { type: 'slider', tagName: 'eevent.config', tagVar: 'blockOpacity', className: ['spl', 'w50'], label: 'sessions.appearence.global.block_opacity' },
          { type: 'radius', tagName: 'eevent.config', tagVar: 'radius', label: 'sessions.appearence.global.rounded' }
        ]
      },
      {
        label: 'sessions.appearence.pages.title',
        controls: [
          { type: 'yes-no', tagName: 'session.mode',  yesLabel: 'sessions.appearence.pages.mode.dark', yesValue: 'dark', noLabel: 'sessions.appearence.pages.mode.light', noValue: 'light', className: 'w50', label: 'sessions.appearence.pages.mode.label' },
          { type: 'titles', tagName: 'eevent.config', tagVar: 'titleBolb',  tagVar2: 'titleItalic', className: 'w50', label: 'sessions.appearence.pages.titles.label' }
        ]
      },
      {
        label: 'sessions.appearence.stream.title',
        controls: [
          { type: 'banner-location', tagName: 'eevent.config', tagVar: 'titleDown', tagVar2: 'hourDisplay',  tagVar3: 'subTitleSpaceOn', className: 'w50', label: 'sessions.appearence.stream.banner_location.label' },
          { type: 'decorative-lines', tagName: 'eevent.config', tagVars: ['lineUp', 'lineDown', 'lineStart', 'lineEnd'], className: ['spl', 'w50'], label: 'sessions.appearence.stream.lines.label' },
          { type: 'title-color', tagName: 'eevent.config', tagVar: 'textColor', className: 'w50', label: 'sessions.appearence.stream.title_color' },
          { type: 'lines-color', tagName: 'eevent.config', tagVars: ['lineUp', 'lineDown', 'lineStart', 'lineEnd'], className: ['spl', 'w50'], labels: ['sessions.appearence.stream.lines.lineUp', 'sessions.appearence.stream.lines.lineDown', 'sessions.appearence.stream.lines.lineStart', 'sessions.appearence.stream.lines.lineEnd']}
        ]
      }
    ],
    eevent_main: [
      {
        label: 'sessions.appearence.global.title',
        controls: [
          { type: 'file', tagName: 'eevent.logo', parseFn: this.parseImage, className: 'w25', label: 'sessions.appearence.global.logo' },
          { type: 'file', tagName: 'eevent.background', parseFn: this.parseImage, className: ['spl', 'w40'], bottomInfo: '1920 x 1080 px', label: 'sessions.appearence.global.bg_image' },
          { type: 'bg-filter', tagName: 'eevent.config', tagVar: 'backgroundFilter', tagVar2: 'backgroundFilterColor', className: ['spl', 'w35'], label: 'sessions.appearence.global.bg_color_filter.label' },
          { type: 'color', tagName: 'eevent.config', tagVar: 'mainColor', className: 'w100', label: 'sessions.appearence.global.main_color' },
          { type: 'color', tagName: 'eevent.config', tagVar: 'blockColor', className: 'w50', label: 'sessions.appearence.global.block_color' },
          { type: 'slider', tagName: 'eevent.config', tagVar: 'blockOpacity', className: ['spl', 'w50'], label: 'sessions.appearence.global.block_opacity' },
          { type: 'radius', tagName: 'eevent.config', tagVar: 'radius', label: 'sessions.appearence.global.rounded' }
        ]
      },
      {
        label: 'sessions.appearence.pages.title',
        controls: [
          { type: 'yes-no', tagName: 'eevent.mode',  yesLabel: 'sessions.appearence.pages.mode.dark', yesValue: 'dark', noLabel: 'sessions.appearence.pages.mode.light', noValue: 'light', className: 'w50', label: 'sessions.appearence.pages.mode.label' },
          { type: 'titles', tagName: 'eevent.config', tagVar: 'titleBolb',  tagVar2: 'titleItalic', className: 'w50', label: 'sessions.appearence.pages.titles.label' }
        ]
      },
      {
        label: 'sessions.appearence.stream.title',
        controls: [
          { type: 'banner-location', tagName: 'eevent.config', tagVar: 'titleDown', tagVar2: 'hourDisplay',  tagVar3: 'subTitleSpaceOn', className: 'w50', label: 'sessions.appearence.stream.banner_location.label' },
          { type: 'decorative-lines', tagName: 'eevent.config', tagVars: ['lineUp', 'lineDown', 'lineStart', 'lineEnd'], className: ['spl', 'w50'], label: 'sessions.appearence.stream.lines.label' },
          { type: 'title-color', tagName: 'eevent.config', tagVar: 'textColor', className: 'w50', label: 'sessions.appearence.stream.title_color' },
          { type: 'lines-color', tagName: 'eevent.config', tagVars: ['lineUp', 'lineDown', 'lineStart', 'lineEnd'], className: ['spl', 'w50'], labels: ['sessions.appearence.stream.lines.lineUp', 'sessions.appearence.stream.lines.lineDown', 'sessions.appearence.stream.lines.lineStart', 'sessions.appearence.stream.lines.lineEnd']}
        ]
      }
    ]
  };

  constructor(
    private route: ActivatedRoute,
    private liveeTagsService: LiveeTagsService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    super.getSession$(this.route.parent.data).subscribe(() => {
      this.loadLiveeTags(this.session.type);
    });
  }

  private loadLiveeTags(sessionType) {
    const tagNames = reduce(
      (acc, g: any) => {
        if (g.controls) {
          g.controls.forEach(c => {
            if (c.tagName) {
              acc = assoc(c.tagName, '', acc);
            }
          });
        }
        return acc;
      },
      {},
      this.content_left[sessionType] || []
    );

    this.liveeTagsService.loadTags(this.session, keys(tagNames)).subscribe(
      liveeTags => {
        this.liveeTags = liveeTags;
        this.previewHash = new Date().getTime();
        this.loaded = true;
      },
      err => {
        console.error(err);
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }

  save() {
    this.liveeTagsService
      .updateTags(
        this.session,
        this.liveeTags
      )
      .subscribe(
        () => {
          toastr.success(this.translateService.instant('action.success'));
        },
        () => {
          toastr.error(this.translateService.instant('action.failed'));
        }
      );  }

  modified() {
    let modified = false;
    keys(this.liveeTags)
      .map(name => this.liveeTags[name])
      .forEach(liveeTag => {
        if (liveeTag.modified()) {
          modified = true;
        }
      });
    return modified;
  }

  parseImage(file: File, cb) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const onLoadEnd = (next: ProgressEvent) => {
      const target: any = next.target;
      const b64image: string = target.result;
      cb(null, { name: file.name, data: b64image });
    };
    const fileReader$ = fromEvent(reader, 'loadend');
    fileReader$.pipe(first(), tap(onLoadEnd)).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/appearence-livee/appearence.component.ts